import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from '../../base/api-service-base';
import { OrderSalesStatusReferenceModel } from "../../models/reference-model/reference-general-model/order-sales-status-reference.model";

@Injectable({
  providedIn: 'root'
})
export class OrderSalesStatusReferenceService extends ApiServiceBase {
  private readonly PATH = "/system/OrderSalesStatusReferences";

  constructor(private httpClient: HttpClient,
    private authService: AuthService) {
      super(httpClient, authService);
  }

  public getOrderSalesStatusReference(): Observable<OrderSalesStatusReferenceModel[]> {
    return this.httpGet<OrderSalesStatusReferenceModel[]>(this.PATH, null)
      .pipe(
        map(
          response => response.body
        )
      )
  }
}
